<div 
	class="placeholder" 
	[style.width]="width" 
	[style.height]="height" 
	[class.centered]="centered" 
	[class.inline]="inline" 
	[style.margin-bottom]="bottomMargin"
	[style.margin-top]="topMargin"></div>